import { register } from '../../../../Javascript/Sysmex/Utils'

const BreadcrumbNavigation = el => {
  el.scrollLeft = 100000
}

register('BreadcrumbNavigation', BreadcrumbNavigation)
